import { axiosInsPaymentLinks } from "./axios";

const get = (url, queryData = {}) => {
    return axiosInsPaymentLinks.get(url, { params: queryData })
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const post = (url, queryData,headers={}) => {
    return axiosInsPaymentLinks.post(url, queryData,{headers})
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const put = (url, queryData) => {
    return axiosInsPaymentLinks.put(url, queryData)
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

const patch = (url, queryData) => {
    return axiosInsPaymentLinks.patch(url, queryData)
        .then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error);
        });
}

export { get, post, put, patch }
